module.exports = __webpack_public_path__ + "static/woman-nature.f4a22c8c.jpg";